import React from 'react'
import PropTypes from 'prop-types'
import { ServerErrorContext } from '../../context'

// ServerError is provided through context by a static or browser application
//
// Static version is fed through react-router-static context
// Browser version comes from a variable attached to window
//
// The browser context provider deals with whether to persist the error or just
// flash it once on page load
const ServerError = ({ renderError, children }) => (
  <ServerErrorContext.Consumer>
    {serverError => (serverError ? renderError(serverError) : children)}
  </ServerErrorContext.Consumer>
)
ServerError.propTypes = {
  renderError: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default ServerError
